import React,{useState,useEffect} from 'react'
import { Link  } from 'react-router-dom';
import { IoIosSearch } from "react-icons/io";
import Popover from '../admin/shared/Popover';  
import Preview from './shared/Preview';
import axios from "axios";
import config from "../config";
import { GENERATED_QRS, PRINT_PRODUCT_QR } from '../common/constants';
import Pagination  from "../common/Pagination";

function QrList() { 
  const [itemsPerPage, setItemsPerPage] = useState(10); 
    const [searchTerm, setSearchTerm] = useState(''); 
    const [PopoverprevId, setPopoverprevId] = useState(null);
    const [selectedPopoverId, setSelectedPopoverId] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'products.name', direction: 'ASC' });
    const [qrList, setQrListData] = useState([]);
    const [selectedQr, setSelectedQr] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchInput, setSearchInput] = useState('');

    const limit = 10; // Number of items per page
    useEffect(() => {
      getQrs();
    }, [currentPage, limit]); // Remove sortConfig from dependencies

    const getQrs = () => {
      axios.post(GENERATED_QRS, {
        params: {
          page: currentPage,
          searchTerm: searchTerm,
          sortKey: sortConfig.key,
          sortOrder: sortConfig.direction,
        },
      }, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        setQrListData(response.data.data);
        setTotalPages(Math.ceil(response.data.total_count / limit));
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
    const handleOpenprevPopover = (id) => {
      setPopoverprevId(id);
    };
  
    const handleCloseprevPopover = () => {
      setPopoverprevId(null);
    };


    const handleOpenPopover = (qrListId) => {

      const foundQr = qrList.find(list => list.id === qrListId);

      if(foundQr)
      {
        setSelectedQr(foundQr);
        setSelectedPopoverId(true);

      }

    };
  
    const handleClosePopover = () => {
      setSelectedPopoverId(false);
    };
   
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
    };
    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
    };
     const handlePrintQrs=(qrListId)=>{

     
      axios.post(PRINT_PRODUCT_QR,{'qr_list_id' : qrListId})
      .then(response => {
        // Handle response
     

       printImages(response.data.data);
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
     }

     const printImages = (images) => {

    };
  
 
  const sortItems = (key) => {
    let direction = 'ASC';
    if (sortConfig.key === key && sortConfig.direction === 'ASC') {
      direction = 'DESC';
    }
    
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    
    // Call API with new sort config directly
    axios.post(GENERATED_QRS, {
      params: {
        page: currentPage,
        searchTerm: searchTerm,
        sortKey: key,
        sortOrder: direction,
      },
    }, {
      headers: {
        'token': localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      setQrListData(response.data.data);
      setTotalPages(Math.ceil(response.data.total_count / limit));
    })
    .catch(error => {
      console.error('Error:', error);
    });
  };
    // const filteredItems = searchTerm ? qrList.filter(item =>
    //   item.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||      
    //   item.dateCreated.includes(searchTerm) || 
    //   (item.isRedeemed ? 'Yes' : 'No').toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   (item.redeemedBy && item.redeemedBy.toLowerCase().includes(searchTerm.toLowerCase()))||
    //   item.rewardPoints.toString().includes(searchTerm)

    // ) : qrList;
    const filteredItems = searchTerm ? qrList.filter(item =>
      (item.product_name && item.product_name.toLowerCase().includes(searchTerm.toLowerCase())) ||      
      (item.created_at && item.created_at.includes(searchTerm)) || 
      ((item.is_scanned ? 'Yes' : 'No').toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.redeemed_by && item.redeemed_by.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.reward_points && item.reward_points.toString().includes(searchTerm))
    ) : qrList;

    const sortedFilteredItems = filteredItems.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  
    // Use filteredItems instead of data for pagination
 

    

    const ViewQr = (id)=>{

        const foundQr = qrList.find(list => list.id === id);

      if(foundQr)
      {
        setSelectedQr(foundQr);
        setSelectedPopoverId(true);

      }

    }
    const handleSearchIconClick = () => {
      setSearchTerm(searchInput);
      setCurrentPage(1);
      
      // Call API with the new search term directly
      axios.post(GENERATED_QRS, {
        params: {
          page: 1,
          searchTerm: searchInput, // Use searchInput directly
          sortKey: sortConfig.key,
          sortOrder: sortConfig.direction,
        },
      }, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        setQrListData(response.data.data);
        setTotalPages(Math.ceil(response.data.total_count / limit));
      })
      .catch(error => {
        console.error('Error:', error);
      });
    };
    
    const handleReset = () => {
      setSearchTerm('');
      setSearchInput('');
      setCurrentPage(1);
      
      // Call API with empty search directly
      axios.post(GENERATED_QRS, {
        params: {
          page: 1,
          searchTerm: '', // Empty search term
          sortKey: sortConfig.key,
          sortOrder: sortConfig.direction,
        },
      }, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        setQrListData(response.data.data);
        setTotalPages(Math.ceil(response.data.total_count / limit));
      })
      .catch(error => {
        console.error('Error:', error);
      });
    };
  return (
    <> 
  
 
    <div className='flex justify-between items-center pt-[70px]'> 
      <div> 
        <h2> QR List</h2>
        <div className='breadcrumbs'> <Link to="/admin/dashboard">Home</Link>{">"} QR List </div>
      </div>
        <div className='flex gap-2 items-center'> 
       
      <div className='flex gap-2 mob-wrap mob-alignfilters'> 
          <div className='flex table-search bg-white w-full'>
          <input
              type="text"
              placeholder="Search"
              value={searchInput}
              onChange={e => setSearchInput(e.target.value)}
              className='w-64'
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearchIconClick();
                }
              }}
            />
           <button type="button" onClick={handleSearchIconClick}>
            <IoIosSearch className="cursor-pointer" />
          </button>
           
          </div>
           {searchTerm && (
            <button 
              type="button"
              onClick={handleReset}
              className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-700 transition"
            >
              Reset
            </button>
          )}
        {/* <select value={sortConfig.key} onChange={(e) => sortItems(e.target.value)} className='sort-dropdown w-full text-gray-900'>
            <option className='text-gray-900' value="" disabled selected>Sort By</option>
            <option className='text-gray-900' value="products.name">Product Name</option>
            <option className='text-gray-900' value="generated_qr_list.reward_points">Reward Points</option>
            <option className='text-gray-900' value="generated_qr_list.created_at">Date Created</option>
          
        </select> */}
        </div>
    <div>
        
      </div> 
    
    </div>
</div>
    
    
    <div  className='whitebox'>
        


    <div>
      <table className='tablegrid table-auto w-full border-collapse border' width={"100%"}>
        <thead>
          <tr className='bg-gray-100 text-left'>
            
            <th className=" py-4 font-medium">S.No</th>
            <th className=" py-4 font-medium">Model</th>

            <th className=" py-4 font-medium">Product Name</th>
            
            <th className=" py-4 font-medium">Reward Points</th>
            <th className=" py-4 font-medium">Is Scanned</th>
            <th   className=" py-4 font-medium">Date Created</th>
           
            <th className=" py-4 font-medium">View</th>
          </tr>
        </thead>
        <tbody>
          {qrList.map((item, index) => (
           <tr key={index}>
           <td>{index + 1 + (currentPage - 1) * limit}</td>
           <td>{item.model_name}</td>

           <td>{item.product_name}</td>
        
           <td>{item.reward_points}</td>
           <td>{(item.is_scanned)? "Yes" : "No"}</td>

           <td>{item.created_at}</td>
       
       
         
           <td className='redfont'><button    onClick={()=>ViewQr(item.id)} > View QR</button></td>
         </tr>
          ))}
        </tbody>
      </table>

    
   
      <div className="flex justify-between mt-5">
          <div> </div>
          <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
             />

        </div>
      </div>

    </div>

    {PopoverprevId && (
          <Popover onClose={handleCloseprevPopover} isVisible={setPopoverprevId !== null}>
            <Preview></Preview>
          </Popover>
        )}
    {selectedPopoverId && (
          <Popover onClose={handleClosePopover} isVisible={selectedPopoverId !== null}>
            <h4  style={{margin:"-20px 20px 10px 0px"}}>View QR</h4>
            <div style={{color:"#000"}} className='flex justify-between'> 
            <div className='pl-5'>
              <div>Product Name</div>
              <div style={{fontSize:"16px",marginBottom:"10px"}}>{selectedQr.product_name}</div>
              <div>Rewards</div>
              <div style={{fontSize:"16px",marginBottom:"10px"}}>{selectedQr.reward_points}</div>
            </div>

            <div className='pl-5'>
              <img src={selectedQr.imageUrl} alt='qrcpde' width="40%" />  

            </div>


            </div>

            {/* <div className='text-center mt-4'> <button style={{width:"100px"}} className='genreport-btn'>Edit</button></div> */}
     
          </Popover>
        )}
    
    </>
  )
}

export default QrList
